export const buildTransitionTasksData = (transitionTaskId, rootTask, level1Tasks, level2Tasks) => {
    const allTasks = [rootTask, ...level1Tasks, ...level2Tasks];
    return {
        transitionTaskId,
        rootTask,
        level1Tasks,
        level2Tasks,
        allTasks,
    }; // Already validated by API calls
};
export const extractRootTask = (rootTaskData) => {
    return rootTaskData.values[0] || null;
};
export const extractTaskIds = (tasks) => {
    return tasks.flatMap((task) => task.children?.tasks?.map((t) => t.id) || []);
};
//# sourceMappingURL=transitionTasksBuilder.js.map